import React, {Fragment} from 'react';
import Button from "../../Button";
import TextInput from '../../TextInput';
import Modal from "../../../layout/Modal";
import Portal from "../../../layout/Portal";
import isEqual from "lodash-es/isEqual";
import {LinkModal} from "./link";
import {set, get, unset} from '../../../../utils/dotutils';
import Select from "../../Select";
import CheckBox from "../../CheckBox";
import {optionsTemplate, ProductSelectSmall} from "../../../../utils/formatters";

class FigureNode extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            editing: false,
            toolbarPos: 'top',
            values: JSON.parse(JSON.stringify(props.node.data.toObject())),
            editvalues: JSON.parse(JSON.stringify(props.node.data.toObject()))
        };
    }

    setData = (data) => {
        const newData = this.props.node.toObject();
        newData.data = {...newData.data.toObject(), ...data};
        const change = this.props.editor.setNodeByKey(this.props.node.key, newData);
        this.props.saveEditing && this.props.saveEditing(change);
        //this.props.onChange({value});
        this.setState({values: newData.data, editvalues: newData.data}, () => this.imgNode.focus());
    }

    setSelected = (e) => {
        e && e.preventDefault();
        const toolbarPos = this.imgNode.offsetTop - this.imgNode.closest(".rt-editor-input").scrollTop > 100 ? 'top' : 'bottom';
        this.setState({toolbarPos});
    }

    clearSelected = (e) => {
        e && e.preventDefault();
    }

    openEditor = (e) => {
        e && e.preventDefault();
        this.setState({editing: true});
    }

    onKeyDown = (e) => {
        e && e.preventDefault();
        if (e.key === "Backspace" || e.key === "Delete") {
            this.deleteImage(e);
        }
    }

    deleteImage = (e) => {
        e && e.preventDefault();
        const change = this.props.editor.removeNodeByKey(this.props.node.key);
        this.props.saveEditing && this.props.saveEditing(change);
    }

    onModalChange = (field, value) => {
        const editvalues = JSON.parse(JSON.stringify({...this.state.editvalues}));
        set(editvalues, "presetdata." + field, value);
        this.setState({editvalues});
    }

    render() {
        const data = ((this.state.values || {}).presetdata || {});
        const editdata = ((this.state.editvalues || {}).presetdata || {});
        const {imgstyle, align, caption} = data;
        const figure_id = (this.state.values || {}).id;
        const src = "index.php?option=figure&figure_id=" + figure_id + "&imgstyle=" + imgstyle + "&resptype=file";

        const actionButtons = [
            {
                text: "Ok",
                props: {color: "primary", className: "pull-right", disabled: isEqual(this.state.values, this.state.editvalues)},
                onClick: async () => {
                    this.setData(this.state.editvalues);
                    this.setState({editing: false});
                }
            }, {
                text: "Mégse",
                props: {color: "default"},
                className: "pull-right",
                onClose: true,
                onClick: async () => {
                    this.setState({editing:false, editvalues: JSON.parse(JSON.stringify(this.state.values))});
                }
            }
        ];
        if (editdata.linktype) {
            actionButtons.push(
                {
                    text: "Link törlése",
                    props: {color: "danger"},
                    className: "pull-left",
                    onClose: true,
                    onClick: async () => {
                        const editvalues = JSON.parse(JSON.stringify({...this.state.editvalues}));
                        unset(editvalues, "presetdata.linktype");
                        unset(editvalues, "presetdata.linkvalue");
                        this.setState({editvalues});
                    }
                }
            );
        }

        return <Fragment>
            <Portal>
                <Modal
                    state={this.state.editing ? "on" : "off"}
                    size="medium"
                    header={"Kép szerkesztése"}
                    buttons={actionButtons}>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <TextInput
                                name="caption"
                                value={editdata.caption}
                                saveChanges={this.onModalChange}
                                label="Képfelirat"
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <Select
                                name="linktype"
                                objectValue={false}
                                optionname="linktype"
                                storeType="local"
                                saveChanges={this.onModalChange}
                                value={editdata.linktype}
                                label="Link típusa"
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-12">
                            { editdata.linktype && editdata.linktype !== "url"
                                ?
                                    <Select
                                        name="linkvalue"
                                        objectValue={false}
                                        component={editdata.linktype}
                                        optionsTemplate={optionsTemplate(editdata.linktype)}
                                        saveChanges={this.onModalChange}
                                        storeType="remote"
                                        value={editdata.linkvalue}
                                        label="Link tárgya"
                                    />
                                :
                                <TextInput name="linkvalue" value={editdata.linkvalue || ''} saveChanges={this.onModalChange} label="Url" />
                            }
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <CheckBox
                                name="linktarget"
                                saveChanges={this.onModalChange}
                                value={editdata.linktarget || '_blank'}
                                checked={!!editdata.linktarget}
                                label="Megnyitás új ablakban"
                            />
                        </div>
                    </div>
                </Modal>
            </Portal>
            <figure ref={(node)=>this.imgNode = node} className={"image " + imgstyle + " align-" + align} tabIndex={-1} onMouseDown={this.setSelected} onFocus={this.setSelected} onBlur={this.clearSelected} onKeyDown={this.onKeyDown}>
                <div className={"image-tools image-tools-" + this.state.toolbarPos + " btn-toolbar"}>
                    <Button
                        onClick={()=>this.setData({...this.state.values, presetdata: {...this.state.values.presetdata, ...{align:'left', imgstyle:'post_side'}}})}
                        icon="align-left"
                        tooltip="Balra rendezés"
                        disabled={align==='left'}
                        color={align==='left' ? "primary" : "default"}
                    />
                    <Button
                        onClick={()=>this.setData({...this.state.values, presetdata: {...this.state.values.presetdata, ...{align:'center', imgstyle:'post_side'}}})}
                        icon="align-center"
                        tooltip="Középre rendezés"
                        disabled={align==='center'&&imgstyle!=='post_full'}
                        color={align==='center'&&imgstyle!=='post_full' ? "primary" : "default"}
                    />
                    <Button
                        onClick={()=>this.setData({...this.state.values, presetdata: {...this.state.values.presetdata, ...{align:'right', imgstyle:'post_side'}}})}
                        icon="align-right"
                        tooltip="Jobbra rendezés"
                        disabled={align==='right'}
                        color={align==='right' ? "primary" : "default"}
                    />
                    <Button
                        onClick={()=>this.setData({...this.state.values, presetdata: {...this.state.values.presetdata, ...{align:'center', imgstyle:'post_full'}}})}
                        icon="align-justify"
                        tooltip="Teljes szélesség"
                        disabled={imgstyle==='post_full'}
                        color={imgstyle==='post_full' ? "primary" : "default"}
                    />
                    <Button
                        onClick={this.openEditor}
                        icon="edit"
                        tooltip="Szerkesztés"
                        color="default"
                    />
                    <Button
                        onClick={this.deleteImage}
                        icon="delete"
                        tooltip="Törlés"
                        color="default"
                    />
                </div>
                <img src={src} />
                {caption ? <div className="image-caption">{caption}</div> : ""}
            </figure>
        </Fragment>;
    }
}

export default FigureNode;